export function getFilesPerDay(fileDates: string[]) {
  const groupedByDay: any = {};

  fileDates.forEach((dateStr) => {
    // Normalize the date to YYYY-MM-DD format
    const date = new Date(dateStr);
    const dayKey = date.toISOString().split('T')[0]; // "YYYY-MM-DD"

    if (!groupedByDay[dayKey]) {
      groupedByDay[dayKey] = 0;
    }

    groupedByDay[dayKey]++;
  });

  // Convert object to sorted array
  const sortedDates = Object.keys(groupedByDay).sort();
  const data = sortedDates.map((date) => ({
    date,
    count: groupedByDay[date],
  }));

  return data;
}
